import React from "react";
import HPButton from "../common/Button";
import { ModalProps } from "../../_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface DiscardConfigurationChangesModalProps extends ModalProps {
  action: () => void;
}

const DiscardConfigurationChangesModal: React.FC<
  DiscardConfigurationChangesModalProps
> = ({ action, closeAction, cancelAction }) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);

  // Use the provided cancel action or fall back to closeTopModal
  const handleCancel = cancelAction || closeAction || closeTopModal;

  return (
    <div className="bg-white w-full rounded-lg shadow-lg flex flex-col max-w-fit mx-auto min-w-[540px]">
      <div className="p-6 flex gap-1">
        <h2 className="text-lg font-semibold">
          Discard configuration changes?
        </h2>
      </div>

      <div className="text-sm border-t border-b border-hp-border-default">
        <div className="p-6 flex flex-col gap-2">
          <p>
            All entered information will be lost. Are you sure you want to
            discard configuration changes?
          </p>
        </div>
      </div>

      <div className="flex justify-end gap-1 p-4">
        <HPButton
          ariaLabel="Continue editing"
          variant="text"
          size="medium"
          color="primary"
          onClick={handleCancel}
          className="text-hp-text-day-primary"
        >
          Continue editing
        </HPButton>

        <HPButton
          ariaLabel="Discard anyway"
          variant="outlined"
          size="medium"
          onClick={action}
          color="error"
        >
          Discard anyway
        </HPButton>
      </div>
    </div>
  );
};

export default DiscardConfigurationChangesModal;
